import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux'
import { MsalProvider } from '@azure/msal-react';
//import msalInstance from './msalConfig';
import { reactAI } from 'react-appinsights';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const store = configureStore();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const Office = window.Office;

Office.onReady((info) => {
    if (info.host === Office.HostType.Outlook) {
        console.log("Office.js is ready in Outlook");

        // Initialize Application Insights
        const appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: 'ce077f16-79b3-4d68-9e0f-56540afc3568',
                extensions: [reactAI],
                extensionConfig: {
                    [reactAI.extensionId]: { debug: false }
                }
            },
        });
        appInsights.loadAppInsights();

        ReactDOM.render(
            <Provider store={store}>
               {/*<MsalProvider instance={msalInstance}>*/}
                    <BrowserRouter basename={baseUrl}>
                        <App />
                    </BrowserRouter>
               {/*// </MsalProvider>*/}
            </Provider>,
            rootElement);
    }
});
 
ReactDOM.render(
 <div className="loadOutSideOffice">This should only be loaded inside Office...</div>,
  // <Provider store={store}>
  // <BrowserRouter basename={baseUrl}>
  //   <App />
  // </BrowserRouter>
  // </Provider>,
  rootElement);

// registerServiceWorker();
unregister();